export enum uiActionType {
  openSidebar = 'OPEN_SIDEBAR',
  closeSidebar = 'CLOSE_SIDEBAR',
  toggleSidebar = 'TOGGLE_SIDEBAR',
  toggleHelper = 'TOGGLE_HELPER',
  openHelper = 'OPEN_HELPER',
  closeHelper = 'CLOSE_HELPER',
  closingHelper = 'CLOSING_HELPER',
  openingHelper = 'OPENING_HELPER',
  registerNavigationModal = 'REGISTER_NAVIGATION_MODAL',
  unregisterNavigationModal = 'UNREGISTER_NAVIGATION_MODAL',
}
